import React, { useState, useEffect } from "react";
import { Link, Switch, Route, useHistory } from "react-router-dom";

import { Avatar, Divider, Dropdown, Icon, Layout, Menu, Row } from "antd";

// import GeneratedReport from "views/generated-reports/GeneratedReports";
import CustomerDashboard from "views/customer-dashboard/CustomerDashboard";
import DealsHubAdmin from "views/dealshubadmin/DealsHubAdmin";
import UserManagment from "views/user-managment/UserManagment";
import NotificationCenter from "views/notification-center/NotificationCenter";
import CardLinkRequest from "views/card-link-request/CardLinkRequest";
import CustomerComplaints from "views/customer-complaints/CustomerComplaints";
import Survey from "views/survey-form/Survey";
import Cohorts from "views/cohort-management/Cohorts";
import PosActivity from "views/pos-activity/PosActivity";
import Stores from "views/stores-management/Stores";
import UserImg from "../../media/profile-img.jpg";
import Synchronize from "views/pos-section/synchronize/Synchronize";
import GeneratedReports from "views/pos-section/generated-reports/GeneratedReports";


import logo from "../../media/CosmoName.png";

import {
    fetchInaamCardLinkRequestCountApi,
    getAdminPermissions,
    fetchInaamCustomerComplaintCountApi,
} from "utils/apiService";

import "./dashboard.less";
import CoinLogo from "../share-points-analytics/images/Coin.svg";
// import DeveloperDash from "views/developer-section/dashboard/Dashboard";
// import Rollout from "views/rollout/Rollout";
// import FeatureDetails from "views/rollout/FeatureDetails";
import SharePointsAnalytics from "views/share-points-analytics/SharePointsAnalytics";
import ReferEarnAnalytics from "views/reffer-and-earn/RefferEarn";

import DateComponent from "components/DateComponent/DateComponent";
import ReactCountryFlag from "react-country-flag";
import { getCountryFlag } from "views/stores-management/StoresTable";

const { Sider, Content } = Layout;

const QueueCounter = ({ fetchCountApi, customersupportflag }) => {
    let [queueCount, setQueueCount] = useState(0);

    const updateCounts = () => {
        if (customersupportflag === "block") {
            fetchCountApi({
                res200Callback: (res) => {
                    setQueueCount(res.data.in_queue);
                },
            });
            setTimeout(updateCounts, 300000);
        }
    };

    useEffect(() => {
        updateCounts();
    }, []);

    return queueCount > 0 ? (
        <span
            style={{
                position: "absolute",
                top: "50%",
                right: "20px",
                transform: "translateY(-50%)",
            }}>
            <span
                style={{
                    padding: "5px 12px",
                    margin: "0 0 0 8px",
                    fontSize: "10px",
                    background: "#e3102f",
                    color: "rgba(255,255,255,0.8)",
                    borderRadius: 100,
                }}>
                {queueCount <= 999 ? queueCount : "999+"}
            </span>
        </span>
    ) : null;
};

const DashBoard = () => {
    const history = useHistory();
    const [collapsed, setCollapsed] = useState(false);
    const [permissionData, setPermissionData] = useState(null);

    const [page, setPage] = useState(
        history.location.pathname.split("/")[1] === "" ? "customer-dashboard" : history.location.pathname.split("/")[1]
    );

    let username = localStorage.getItem("username");
    let usertype = localStorage.getItem("user_type");

    let analyticsflag = permissionData?.findIndex((item) => item === "ANALYTICS") >= 0 || false ? "block" : "none";
    let reportsflag = permissionData?.findIndex((item) => item === "REPORTS") >= 0 || false ? "block" : "none";
    let storecontrolflag =
        permissionData?.findIndex((item) => item === "STORE_CONTROL_CENTER") >= 0 || false ? "block" : "none";

    let customersupportflag =
        permissionData?.findIndex((item) => item === "CUSTOMER_SUPPORT") >= 0 || false ? "block" : "none";

    let useradministrationflag =
        (permissionData?.findIndex((item) => item === "USER_ADMINISTRATION") >= 0 || false) &&
            usertype === "super_admin"
            ? "block"
            : "none";

    const fetchpermission = () => {
        getAdminPermissions({
            requestData: {
                username: username,
            },
            res200Callback: (res) => {
                setPermissionData(res.data.permission_list);
            },
        });
    };

    const handleLogout = () => {
        localStorage.clear();
        history.go(0);
    };

    useEffect(() => {
        fetchpermission();
        // setPermissionData(["ANALYTICS", "STORE_CONTROL_CENTER", "USER_ADMINISTRATION", "CUSTOMER_SUPPORT"]);
    }, []);

    useEffect(() => {
        setPage(
            history.location.pathname.split("/")[1] === ""
                ? "customer-dashboard"
                : history.location.pathname.split("/")[1]
        );
    }, [history.location.pathname]);

    const Temple = ({ permissionname, displayflag }) => {
        return (
            <div
                style={{
                    padding: "0px 18px",
                    width: "290px",
                    display: displayflag,
                }}>
                <div
                    style={{
                        letterSpacing: "2px",
                        margin: "10px 0px 10px 0px",
                        fontSize: "12px",
                        color: "#ffffff",
                        alignSelf: "center",
                        flex: "none",
                        opacity: "50%",
                        marginBottom: "15px",
                    }}>
                    {permissionname}
                </div>
            </div>
        );
    };

    return (
        <>
            <Layout>
                <div
                    style={{
                        position: "fixed",
                        top: "0",
                        right: "0",
                        width: "100%",
                        padding: "15px 30px",
                        // background: "#FAFAFA",
                        // zIndex: "10",
                        // boxShadow:"0 2px rgba(0, 0, 0, 0.1)"
                    }}>
                    <Row type='flex' align='middle' justify='end' className='header-container'>
                        <DateComponent />
                        <Dropdown
                            overlay={
                                <Menu mode='horizontal'>
                                    <Menu.Item>
                                        <a onClick={handleLogout}>Logout</a>
                                    </Menu.Item>
                                </Menu>
                            }
                            trigger={["click"]}>
                            <a className='ant-dropdown-link' style={{ textTransform: "capitalize", fontSize: "14px" }}>
                                <Avatar size={32} src={UserImg} className='margin-right-5' />
                                {username} <Icon type='down' style={{ color: "#6E7191" }} />
                            </a>
                        </Dropdown>
                    </Row>
                </div>

                <Layout>
                    <Sider
                        style={{
                            background: "#272727",
                            position: "fixed",
                            top: 0,
                            bottom: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            zIndex: 20,
                            // paddingTop: 40
                            // color: "#fff"
                        }}
                        trigger={null}
                        collapsible
                        collapsed={collapsed}
                    // className={this.state.collapsed ? "hide-on-small" : "overlay " + "sider"}
                    >
                        <div className='logo' style={{ display: "flex", alignItems: "flex-end" }}>
                            <img
                                src={logo}
                                style={{
                                    height: "40px",
                                    width: "100px",
                                }}
                            />
                            <ReactCountryFlag
                                countryCode={JSON.parse(localStorage.getItem("countryData"))?.short_name || "AE"}
                                svg
                                style={{
                                    height: "23px",
                                    width: "23px",
                                    borderRadius: "20px",
                                    backgroundColor: "black",
                                    objectFit: "cover",
                                    marginLeft: "5px",
                                    alignSelf: "center"
                                }}
                            />
                        </div>

                        <Menu
                            mode='vertical'
                            style={{
                                backgroundColor: "#272727",
                            }}
                            defaultSelectedKeys={[page]}
                            onSelect={({ key }) => {
                                setPage(key);
                            }}>
                            <Temple permissionname={"Analytics"} displayflag={analyticsflag} />
                            <Menu.Item
                                key='customer-dashboard'
                                style={{
                                    display: analyticsflag,
                                    marginBottom: "40px",
                                }}>
                                <Link to='/'>
                                    <div
                                        style={
                                            page === "customer-dashboard"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0 -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='appstore'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "customer-dashboard" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "customer-dashboard" ? "bold" : "normal"}`,
                                            }}>
                                            App Analytics
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>

                            <Temple permissionname={"Reports"} displayflag={reportsflag} />
                            <Menu.Item
                                key='generated-reports'
                                style={{
                                    display: reportsflag,
                                }}>
                                <Link to='/generated-reports'>
                                    <div
                                        style={
                                            page === "generated-reports"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0 -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='file-excel'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "generated-reports" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "generated-reports" ? "bold" : "normal"}`,
                                            }}>
                                            Reports
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key='app-feedback'
                                style={{
                                    display: reportsflag,
                                    marginBottom: "40px",
                                }}>
                                <Link to='/app-feedback'>
                                    <div
                                        style={
                                            page === "app-feedback"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0px -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='audit'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "/app-feedback" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "app-feedback" ? "bold" : "normal"}`,
                                            }}>
                                            Survey
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>

                            <Temple permissionname={"Store Control Center"} displayflag={storecontrolflag} />
                            <Menu.Item
                                key='deals-hub-admin-sections'
                                style={{
                                    display: storecontrolflag,
                                }}>
                                <Link to='/deals-hub-admin-sections'>
                                    <div
                                        style={
                                            page === "deals-hub-admin-sections"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0 -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='sound'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "deals-hub-admin-sections" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "deals-hub-admin-sections" ? "bold" : "normal"
                                                    }`,
                                            }}>
                                            Deals Hub
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key='notification-center'
                                style={{
                                    display: storecontrolflag,
                                }}>
                                <Link to='/notification-center'>
                                    <div
                                        style={
                                            page === "notification-center"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0 -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='bell'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "notification-center" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "notification-center" ? "bold" : "normal"}`,
                                            }}>
                                            Notification Center
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key='stores-management'
                                style={{
                                    display: storecontrolflag,
                                }}>
                                <Link to='/stores-management'>
                                    <div
                                        style={
                                            page === "stores-management"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0 -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='shop'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "stores-management" ? "bold" : "normal"}`,
                                            }}>
                                            Nujoom Stores
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key='cohorts'
                                style={{
                                    display: storecontrolflag,

                                    marginBottom: "40px",
                                }}>
                                <Link to='/cohorts'>
                                    <div
                                        style={
                                            page === "cohorts"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0px -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='cluster'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "cohorts" ? "bold" : "normal"}`,
                                            }}>
                                            Cohort Management
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>

                            <Temple permissionname={"Customer Support"} displayflag={customersupportflag} />
                            <Menu.Item
                                key='customer-complaints'
                                style={{
                                    display: customersupportflag,
                                }}>
                                <Link to='/customer-complaints'>
                                    <div
                                        style={
                                            page === "customer-complaints"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0px -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='mail'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "customer-complaints" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "customer-complaints" ? "bold" : "normal"}`,
                                            }}>
                                            Customer Complaints
                                        </span>
                                    </div>
                                    {
                                        customersupportflag == 'block' && <QueueCounter fetchCountApi={fetchInaamCustomerComplaintCountApi} customersupportflag={customersupportflag} />
                                    }
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key='helpdesk'
                                style={{
                                    display: customersupportflag,
                                    marginBottom: "40px",
                                }}>
                                <Link to='/helpdesk'>
                                    <div
                                        style={
                                            page === "helpdesk"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0px -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='customer-service'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                            theme={page === "helpdesk" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "helpdesk" ? "bold" : "normal"}`,
                                            }}>
                                            Help Desk
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>

                            <Temple permissionname={"User Administration"} displayflag={useradministrationflag} />
                            <Menu.Item
                                key='admin-member'
                                style={{
                                    display: useradministrationflag,
                                }}>
                                <Link to='/admin-member'>
                                    <div
                                        style={
                                            page === "admin-member"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0 -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='key'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "admin-member" ? "bold" : "normal"}`,
                                            }}>
                                            Admin Members
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key='pos-activity'
                                style={{
                                    display: useradministrationflag,
                                }}>
                                <Link to='/pos-activity'>
                                    <div
                                        style={
                                            page === "pos-activity"
                                                ? {
                                                    background:
                                                        "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
                                                    margin: "0px -16px",
                                                    padding: "0 16px",
                                                }
                                                : {}
                                        }>
                                        <Icon
                                            type='robot'
                                            style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        <span
                                            style={{
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                lineHeight: "22px",
                                                fontWeight: `${page === "pos-activity" ? "bold" : "normal"}`,
                                            }}>
                                            POS Members
                                        </span>
                                    </div>
                                </Link>
                            </Menu.Item>

                            {/* <Menu.Item key="refer-earn-analytics">
								<Link to="/refer-earn-analytics">
									<div
										style={
											page === "refer-earn-analytics"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="share-alt"
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
											}}
											theme="outlined"
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "refer-earn-analytics" ? "bold" : "normal"}`,
											}}>
											Refer and Earn
										</span>
									</div>
								</Link>
							</Menu.Item> */}
                        </Menu>
                    </Sider>

                    <Content
                        style={{
                            // display: "flex",
                            // justifyContent: "center",
                            // maxWidth: "1300px",
                            margin: "0 0 0 290px",
                            background: "#E5E5E5",
                            minHeight: "100vh",
                            height: "max-content",
                        }}>
                        <Switch>
                            {/* {permissionData?.findIndex((item) => item === "ANALYTICS") >= 0 || false ? (
                                <>
                                    <Route exact path='/' component={CustomerDashboard} />
                                    <Route path='/app-feedback' component={Survey} />
                                    <Route exact path='/generated-reports' component={GeneratedReport} />
                                </>
                            ) : (
                                <></>
                            )}
                            {permissionData?.findIndex((item) => item === "CUSTOMER_SUPPORT") >= 0 || false ? (
                                <Route exact path='/customer-complaints' component={CustomerComplaints} />
                            ) : (
                                <></>
                            )}
                            {permissionData?.findIndex((item) => item === "STORE_CONTROL_CENTER") >= 0 || false ? (
                                <>
                                    <Route exact path='/deals-hub-admin-sections' component={DealsHubAdmin} />
                                    <Route exact path='/notification-center' component={NotificationCenter} />
                                    <Route path='/stores-management' component={Stores} />
                                    <Route path='/cohorts' component={Cohorts} />
                                </>
                            ) : (
                                <></>
                            )}

                            {permissionData?.findIndex((item) => item === "USER_ADMINISTRATION") >= 0 || false ? (
                                <>
                                    <Route path='/pos-activity' component={PosActivity} />
                                    <Route path='/admin-member' component={UserManagment} />
                                </>
                            ) : (
                                <></>
                            )} */}

                            {/* <Route exact path='/' component={analyticsflag === "block" ? CustomerDashboard : (storecontrolflag === "block" ? DealsHubAdmin : CustomerComplaints)} /> */}
                            <Route exact path='/' component={CustomerDashboard} />
                            <Route path='/app-feedback' component={Survey} />
                            <Route exact path='/generated-reports' component={GeneratedReports} />

                            <Route exact path='/deals-hub-admin-sections' disable component={DealsHubAdmin} />
                            <Route exact path='/notification-center' component={NotificationCenter} />
                            <Route path='/stores-management' component={Stores} />
                            <Route path='/cohorts' component={Cohorts} />
                            <Route exact path='/customer-complaints' component={CustomerComplaints} />
                            <Route path='/pos-activity' component={PosActivity} />
                            <Route path='/admin-member' component={UserManagment} />
                            <Route path='/helpdesk' component={Synchronize} />
                            <Route path='/share-points-analytics' component={SharePointsAnalytics} />
                            <Route
                                path='*'
                                component={() => (
                                    <Row
                                        type='flex'
                                        justify='space-between'
                                        align='middle'
                                        style={{
                                            width: "100%",
                                            padding: "40px 25px 0",
                                            margin: "60px auto 20px",
                                            backgroundColor: "#FAFAFA",
                                        }}>
                                        404 NOT FOUND
                                    </Row>
                                )}></Route>
                        </Switch>
                    </Content>
                </Layout>
            </Layout>
        </>
    );
};

export default DashBoard;
